import { z } from 'zod';

export const MyBenchCardEngageModalSchema = z.object({
  description: z.string().max(300),
});

export type MyBenchCardEngageModalType = z.infer<
  typeof MyBenchCardEngageModalSchema
>;
